/**
 * Replace [potential_points] in product callouts with Rivo points.
 * Loaded from sections/main-product--default.liquid as type="module".
 */

const SENTINEL = '[potential_points]'
const POINTS_SELECTOR = '.order-placed-potential-points-amount'
const CALLOUTS_SELECTOR = '.product__callouts-item-text p'
const POLL_MS = 200
const POLL_MAX = 30

const originals = new Map()

function apply(value) {
  if (!value) return false

  let replaced = false

  for (const el of document.querySelectorAll(CALLOUTS_SELECTOR)) {
    if (!originals.has(el) && el.textContent.includes(SENTINEL)) {
      originals.set(el, el.textContent)
    }

    const original = originals.get(el)
    if (!original) continue

    el.textContent = original.replaceAll(SENTINEL, value)
    replaced = true
  }

  if (replaced) {
    const widget = document.querySelector('#loy-potential-points')
    if (widget) widget.style.display = 'none'
  }

  return replaced
}

function bind(pointsEl) {
  if (!apply(pointsEl.textContent.trim())) return

  new MutationObserver(() => apply(pointsEl.textContent.trim())).observe(pointsEl, {
    childList: true,
    subtree: true,
    characterData: true,
  })
}

function waitForPoints(attempt = 0) {
  const el = document.querySelector(POINTS_SELECTOR)
  if (el?.textContent.trim()) {
    bind(el)
    return
  }
  if (attempt >= POLL_MAX) return
  setTimeout(() => waitForPoints(attempt + 1), POLL_MS)
}

waitForPoints()
